import { Dispatch } from "redux";
import axios from "axios";

import React from "react";
import { LoginWithApp } from "./LoginWithApp";
import { GlobalError } from "../../../components/errors/GlobalError";
import { GetApplication, GetApplicationVersion } from "utilityFunctions";
import { ConvertError } from "Helper/ErrorMessageHelper";
import { NavigateFunction } from "react-router-dom";

export const LoginWithDiscord =
  (
    language: string,
    token: string,
    persistentLogin: boolean,
    signup: boolean,
    setRedirect: React.Dispatch<React.SetStateAction<boolean>>,
    navigate: NavigateFunction,
    qrTokenToValidate?: string,
    referrerEmail?: string
  ) =>
  async (dispatch: Dispatch<any>) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const promotionCode = localStorage.getItem("promoCode");

    const loginWithAppRequest = {
      application: await GetApplication(),
      applicationVersion: GetApplicationVersion(),
      token,
      qrTokenToValidate: qrTokenToValidate,
      referrerEmail,
      promotionCode: !!promotionCode ? promotionCode : undefined,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": language === "en" ? "en-US;" : "fr-CA;",
      },
    };
    console.log("this is loginWithAppRequest", loginWithAppRequest);

    try {
      const loginWithAppResponse = await axios.post(
        `${BASE_URL}/api/auth/${!!signup ? "signup" : "login"}WithDiscord`,
        loginWithAppRequest,
        config
      );
      console.log("this is the loginWithAppResponse", loginWithAppResponse);
      if (loginWithAppResponse.status === 200) {
        const { accessToken, refreshToken } = loginWithAppResponse.data;
        LoginWithApp(
          accessToken,
          refreshToken,
          persistentLogin,
          dispatch,
          setRedirect
        );
      }
    } catch (error: any) {
      const convertedError = ConvertError(error);
      if (convertedError.errorType === "EmailAlreadyInUseException") {
        return GlobalError("emailInUseLong", () => {
          navigate("/login", {
            state: {
              qrTokenToValidate: !!qrTokenToValidate
                ? qrTokenToValidate
                : undefined,
            },
          });
        });
      }
      if (convertedError.errorType === "UserNotFoundException") {
        return GlobalError("UserNotFoundException", () => {
          navigate("/signup", {
            state: {
              qrTokenToValidate: !!qrTokenToValidate
                ? qrTokenToValidate
                : undefined,
            },
          });
        });
      }
      GlobalError(error);
      console.log("there has been an error", error.response);
    }
  };
